var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-links"},_vm._l((_vm.routerLinks),function(router){return _c('button',{key:router,class:{ active: _vm.activeType == router },on:{"click":function($event){return _vm.addActive(router)}}},[_vm._v(" "+_vm._s(router)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }